import axiosClient from "utils/axios";
import { ApiResponse } from "types/api.types";
import type {
  CreateEmployeeSalaryStructurePayload,
  EmployeeSalaryStructure,
  UpdateEmployeeSalaryStructurePayload,
} from "../types/employee-salary-structure.types";

export const listEmployeeSalaryStructures = async (employeeId: number) => {
  const response = await axiosClient.get<ApiResponse<EmployeeSalaryStructure[]>>(
    `/employees/${employeeId}/salary-structures`,
  );
  return response.data;
};

export const getEmployeeSalaryStructure = async (
  employeeId: number,
  structureId: number,
) => {
  const response = await axiosClient.get<ApiResponse<EmployeeSalaryStructure>>(
    `/employees/${employeeId}/salary-structures/${structureId}`,
  );
  return response.data;
};

export const createEmployeeSalaryStructure = async (
  employeeId: number,
  payload: CreateEmployeeSalaryStructurePayload,
) => {
  const response = await axiosClient.post<ApiResponse<EmployeeSalaryStructure>>(
    `/employees/${employeeId}/salary-structures`,
    payload,
  );
  return response.data;
};

export const updateEmployeeSalaryStructure = async (
  employeeId: number,
  structureId: number,
  payload: UpdateEmployeeSalaryStructurePayload,
) => {
  const response = await axiosClient.put<ApiResponse<EmployeeSalaryStructure>>(
    `/employees/${employeeId}/salary-structures/${structureId}`,
    payload,
  );
  return response.data;
};

export const deleteEmployeeSalaryStructure = async (
  employeeId: number,
  structureId: number,
) => {
  const response = await axiosClient.delete<ApiResponse<unknown>>(
    `/employees/${employeeId}/salary-structures/${structureId}`,
  );
  return response.data;
};
